import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskFiles.title',
    defaultMessage: 'Task Files',
  },
  confirm: {
    id: 'containers.OrderPage.components.TaskFiles.Delete.confirm',
    defaultMessage: 'Are you sure you want to delete this file?',
  },
})
